module.exports = __webpack_public_path__ + "img/settings.56032c53.svg";